import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@mui/material";
import classes from "./SummaryAsProductNo.module.scss";
import React, { FC, memo, useState } from "react";
import { processInfo, summaryByProductNo } from "../../../../types/dirary";
import AddButton from "../../../uikit/atoms/buttons/AddButton";
import { formatDate } from "../../../../utils/functions/formatting";
import SingleInputModal from "../Modal/SingleInputModal";
type Props = {
  summary: summaryByProductNo;
  children: React.ReactNode;
  processList: processInfo[];
};

const getEstimatedTime = (
  processList: processInfo[],
  summary: summaryByProductNo
) => {
  const filteredProcessList = processList.filter(
    (process: processInfo) =>
      process.productNo === summary.productNo &&
      process.productBno === summary.productBno
  );
  const totalEstimatedTime = filteredProcessList.reduce(
    (total, process) => total + Number(process.estimatedTime),
    0
  );
  return totalEstimatedTime;
};

const SummaryAsProductNo: FC<Props> = memo(
  ({ children, summary, processList }) => {
    const [expanded, setExpanded] = React.useState(false);
    const theme = useTheme();
    const [isShowSingleInputModal, setIsShowSingleInputModal] = useState(false);

    const handleExpansion = () => {
      setExpanded((prevExpanded) => !prevExpanded);
    };

    return (
      <>
        <div className={classes.rootContainer}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            sx={{
              backgroundColor: theme.palette.backColor.dark,
              padding: "0px 0px",
            }}
          >
            <AccordionSummary
              expandIcon={
                expanded ? (
                  <RemoveIcon
                    sx={{
                      padding: "0px",
                      color: theme.palette.foreColor.main,
                      "&:hover": {
                        color: theme.palette.foreColor.light,
                      },
                    }}
                  />
                ) : (
                  <AddIcon
                    sx={{
                      color: theme.palette.foreColor.main,
                      "&:hover": {
                        color: theme.palette.foreColor.light,
                      },
                    }}
                  />
                )
              }
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                borderRadius: "10px",
                boxShadow: "0px 0px 3px 1px #898b92",
                backgroundColor: theme.palette.backColor.dark,
              }}
            >
              <div className={classes.summary}>
                <div className={classes.addButton}>
                  <AddButton
                    label={"新規"}
                    disabled={false}
                    onClick={(event: any) => {
                      event.stopPropagation();
                      setIsShowSingleInputModal(true);
                    }}
                  />
                </div>

                <div>
                  <p>
                    製番 <span>{summary.factoryName}</span>
                  </p>
                  <p className={classes.productNo}>
                    {summary.productNo}-{summary.productBno}
                  </p>
                </div>
                <div>
                  <p>工事区分</p>
                  <p className={classes.construction}>
                    {summary.constructionName}
                  </p>
                  {/* <p className={classes.construction}>受架台組立工事</p> */}
                </div>
                <div>
                  <p>予定工数</p>
                  <p className={classes.number}>
                    {getEstimatedTime(processList, summary).toFixed(1)}
                  </p>
                  {/* <p className={classes.number}>11111.1</p> */}
                </div>
                <div>
                  <p>作業時間</p>
                  <p className={classes.number}>
                    {summary.totalWorkingTimeByHour.toFixed(1)}
                  </p>
                  {/* <p className={classes.number}>11111.1</p> */}
                </div>

                <div>
                  <p>人員数</p>
                  <p className={classes.number}>{summary.numberOfWorkers}</p>
                </div>
                <div className={classes.siteName}>
                  <p>現場名</p>
                  <p>{summary.siteName}</p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                backgroundColor: theme.palette.backColor.light,
                padding: "5px 0px",
              }}
            >
              {children}
            </AccordionDetails>
          </Accordion>
        </div>
        {isShowSingleInputModal && (
          <SingleInputModal
            setIsShow={setIsShowSingleInputModal}
            dateString={formatDate(new Date())}
            workerId={""}
            callFrom={"listByNew"}
            initialProductNo={summary.productNo}
            initialProductBno={summary.productBno}
          />
        )}
      </>
    );
  }
);

export default SummaryAsProductNo;
